const environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = Object.assign({
  host: (process.env.HOST),
  port: process.env.PORT,
  // apiPath: "https://ntpdev03.ntptrader.com/api",
  // wsRatePath: "wss://ntpdev03.ntptrader.com/ws",
  // wsOrderPath: "wss://ntpdev03.ntptrader.com/ws",
  apiPath: "https://stg02.ntptrader.com/api",
  wsRatePath: "wss://stg02.ntptrader.com/ws",
  wsOrderPath: "wss://stg02.ntptrader.com/ws",
  webSocketTimeOut: 5000,
  instrument_listHeader: 'Instrument List',
  Trade_Panel_Header: 'Trading Widget',
  CmdtyHeader: 'Pair',
  BidHeader: 'Bid',
  AskHeader: 'Ask',
  highHeader: 'High',
  lowHeader: 'Low',
  prevHeader: 'Previous close',
  QuantityHeader: 'Quantity',
  ChartHeader: 'Chart',
  OutstandingOrderHeader: 'Trade Book',
  TradebookHeader: 'Trade Book',
  Activity_Header: 'Activity Log ',
  News_Header: 'News Feed',
  ChartHeader: 'Chart',
  heartBeatTime: 5000,
  roundOff: 2,
  AmountRoundOFF: 2,
  QuantityRoundOff: 3,
  companyList: process.env.CompanyList,
  location: process.env.Location,
  footerAddrOne: process.env.footerAddrOne,
  footerAddrTwo: process.env.footerAddrTwo,
  footerAddrThree: process.env.footerAddrThree,
  website: process.env.website,
  websiteURL: process.env.websiteURL,
  websiteText: process.env.websiteText,
  extraText: process.env.extraText,
  buy: 'BUY',
  sell: 'SELL',
  stopBuy: 'STOP BUY',
  stopSell: 'STOP SELL',
  increaseRateColor: '#106AA9',
  decreaseRateColor: '#D62727',
  app: {
    title: process.env.TITLE,
    head: {
      meta: [
        { name: 'description', content: 'Orosoft Solutions Pvt. Ltd.' },
        { charset: 'utf-8' },
        { property: 'og:site_name', content: process.env.TITLE },
        { property: 'og:image', content: '' },
        { property: 'og:locale', content: 'en_US' },
        { property: 'og:title', content: process.env.TITLE },
        { property: 'og:description', content: process.env.TITLE },
        { property: 'og:card', content: 'summary' },
        { property: 'og:site', content: '' },
        { property: 'og:creator', content: '' },
        { property: 'og:image:width', content: '200' },
        { property: 'og:image:height', content: '200' }
      ]
    }
  },



}, environment);
